import { Flex, Kbd } from '@chakra-ui/react'
import React from 'react'
import Text, { FontStyle } from '~/components/core/Text'

interface KeyboardKeyProps {
  text?: string
  fontStyle?: FontStyle
  textColor?: string
  height?: number
  width?: number | 'auto'
}

const KeyboardKeyWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex justifyContent={'center'} alignItems={'center'}>
      {children}
    </Flex>
  )
}

interface KeyBoxProps {
  width: string
  height: number
  children?: React.ReactNode
}

const KeyBox = ({ children }: KeyBoxProps) => {
  return (
    <Kbd
      css={{
        minWidth: '1.875rem',
        width: 'auto',
        height: '1.875rem',
        padding: '0.5rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        marginRight: '0.5rem',
        backgroundColor: 'bg.default',
        color: 'fg.default',
      }}
    >
      {children}
    </Kbd>
  )
}

const KeyboardKey = ({
  text = '',
  fontStyle = FontStyle.Normal,
  textColor = 'fg.default',
  height = 30,
  width = 'auto',
}: KeyboardKeyProps) => {
  return (
    <KeyboardKeyWrapper>
      <KeyBox height={height} width={width === 'auto' ? width : `${width}px`}>
        <Text text={text} fontStyle={fontStyle} color={textColor} />
      </KeyBox>
    </KeyboardKeyWrapper>
  )
}

export default KeyboardKey
export type { KeyboardKeyProps }
